var n=function(n){return function(){return n}};export{n as c};
